const SIGNUP_FORM_KEY = "2_hotel-achat-2026.yml";
import SIGNUP_FORM_INFO from "@/.global-data/form-info/2_hotel-achat-2026.yml";
import SignupForm from "@/components/signup-form";
import dynamicLocalization from "@/mixins/dynamic-localization";
import SimplePage from "@/components/simple-page/index";
import PAGE from "./page.yaml";

export default {
  components: { SignupForm, SimplePage },
  mixins: [dynamicLocalization],
  data() {
    return {
      formKey: SIGNUP_FORM_KEY,
      formInfo: SIGNUP_FORM_INFO,
      sections: PAGE.sections,
      title: PAGE.title,
    };
  },
  methods: {},
};
